import { ISummaryTableDataNode } from 'components/common/SummaryTable/SummaryTable.properties';

const schema: ISummaryTableDataNode[] = [
    {
        objectName: '',
        isLoading: 'purchaseOrderLoading',
        title: 'Purchase order details',
        children: [
            {
                label: 'Purchase Order',
                fieldNames: ['PurchaseOrder'],
            },
            {
                label: 'Supplier',
                fieldNames: [
                    'SupplierDisplay',
                    'SupplierDisplayLabel',
                    'SupplierCityState'
                ],
            },
            {
                label: 'Entity',
                fieldNames: [
                    'Entity',
                    'EntityLabel'
                ],
            },
            {
                label: 'Category',
                fieldNames: [
                    'PurchaseOrderCategoryDisplay',
                    'PurchaseOrderCategoryDescription'
                ],
            },
            {
                label: 'Type',
                fieldNames: [
                    'OrderType',
                    'OrderTypeDescription',
                ],
            },
            {
                label: 'Status',
                dialogBox: {
                    color: 'Amber',
                    fieldName: 'AlertMessage',
                    icon: 'Warning',
                    title: 'Alert',
                    tableCell: 'value'
                },
                fieldNames: [
                    'Status',
                ],
            },

        ]
    },
    {
        objectName: '',
        isLoading: 'purchaseOrderLoading',
        children: [
            {
                label: 'Created',
                fieldNames: [
                    'CreatedDate',
                ],
            },
            {
                label: 'Earliest Due',
                fieldNames: [
                    'DueDate',
                ],
            },
            {
                label: 'Ship',
                fieldNames: [
                    'ShipDate',
                ],
            },
            {
                label: 'Last Transmit',
                fieldNames: [
                    'TransmitDate',
                ],
            },
        ]
    },
    {
        objectName: '',
        isLoading: 'purchaseOrderLoading',
        title: 'Totals',
        children: [
            {
                label: 'Currency',
                fieldNames: [
                    'Currency',
                ],
            },
            {
                label: 'Outstanding',
                fieldNames: [
                    'OutstandingDisplay',
                ],
                valueRenderer: {
                    isNumericDisplay: true
                }
            },
            {
                label: 'Order Total',
                fieldNames: [
                    'OrderTotalDisplay',
                ],
                valueRenderer: {
                    isNumericDisplay: true
                }
            },
            {
                label: 'Tax Included Prices',
                fieldNames: [
                    'TaxIncludedDisplay',
                ],
            },
        ]
    },
];

export default schema;
